import { useState } from "react";
import extractInvoiceData from "./extractInvoiceData";
import Navbar from "./components/Navbar";
import FileUpload from "./components/FileUpload";
import InvoiceData from "./components/InvoiceData";
import PDFViewer from "./components/PDFViewer";

function App() {
  const [parsedData, setParsedData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pdfFile, setPdfFile] = useState(null); // ✅ Store Base64 PDF

  const handleFileUpload = async (file) => {
    setParsedData(null);
    setPdfFile(null);
    setLoading(true);
    console.log("📄 Selected File:", file.name);

    // ✅ Extract Invoice Data & Get PDF from API
    const response = await extractInvoiceData(file);
    if (response) {
      setParsedData(response.invoiceData);
      setPdfFile(response.pdfFile); // ✅ Store Base64 PDF
    }

    setLoading(false);
  };

  return (
    <div className="container">
      <Navbar />
      <div className="main-container">
        <div className="content">
          <FileUpload onUpload={handleFileUpload} />
          {loading && <p className="loading">⏳ Processing Invoice... Please wait.</p>}
        </div>

        <div className="viewer-data-container">
          <InvoiceData parsedData={parsedData} />
          {(loading || pdfFile) && <PDFViewer base64={pdfFile} />} {/* ✅ Show PDF only if available */}
        </div>
      </div>
      <footer className="footer">© {new Date().getFullYear()} Autofolio. All rights reserved.</footer>
    </div>
  );
}

export default App;
